import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    footer: _defineProperty({
      padding: componentTheme.footerPadding,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }, mp, {
      display: 'none'
    }),
    oqaatFooter: _defineProperty({
      padding: '0 1rem',
      margin: "".concat(componentTheme.oqaatFooterMargin, " 0"),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }, mp, {
      display: 'none'
    })
  };
};
export default generateStyle;